function consoleHost(region: string): string {
  if (region.startsWith('us-gov-')) {
    return 'https://console.amazonaws-us-gov.com';
  }
  return 'https://console.aws.amazon.com';
}

export function ec2InstanceUrl(region: string, instanceId: string): string {
  return `${consoleHost(region)}/ec2/home?region=${region}#InstanceDetails:instanceId=${instanceId}`;
}

export function asgUrl(region: string, asgName: string): string {
  return `${consoleHost(region)}/ec2/home?region=${region}#AutoScalingGroupDetails:id=${asgName};view=details`;
}

export function rdsUrl(region: string, dbInstanceIdentifier: string): string {
  return `${consoleHost(region)}/rds/home?region=${region}#database:id=${dbInstanceIdentifier};is-cluster=false`;
}
